module.exports = __webpack_public_path__ + "img/splitine.e2e36c6.png";